module.exports = __webpack_public_path__ + "img/lCallH.fd572182.svg";